// EnrollmentDetailsModal.js
import React from 'react';
import './EnrollmentDetailsModal.css';

const EnrollmentDetailsModal = ({ isOpen, onClose, data }) => {
    if (!isOpen) return null;

    return (
        <div className="custom-modal">
            <div className="custom-modal-content">
                <span className="close" onClick={onClose}>&times;</span>
                <h3>Completed Enrollments</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Alias</th>
                            <th>Core Competency Code</th>
                            <th>Status</th>
                            <th>Site</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index}>
                                <td>{item.etp_mstr_alias}</td>
                                <td>{item.etp_mstr_core_comp_code}</td>
                                <td>{item.etp_mstr_wd_core_comp_status}</td>
                                <td>{item.etp_mstr_site}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default EnrollmentDetailsModal;
